var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h1',{staticClass:"h4"},[_vm._v("Faturamento de evoluções")]),_c('p',{attrs:{"role":"status"}},[_vm._v(_vm._s(_vm.message))]),_c('p',[_vm._v("Consulta, seleção e preview fiscal são realizados na tela de faturamento de evoluções.")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }